export const url = {
  login: "/login",
  users:"/users",
  list_country: "/countries",
  add_country: "/countries",
  edit_country: "/countries",
  delete_country: "/countries",
  profile:"/my-profile",
  logout:"/logout",
  states:"/states",
  genres:"/genres",
  feedbacks:"/feedback",
  roles:"/roles",
  permissions:"/permissions",
  districts:"/districts",
  voices:"/voices",
  presigned_url:"/presigned-url",
  banners:"/banners",
  payments:"/payments",
  authors:"/original-authors",
  memberships:"/membership-plans",
  mediums:"/mediums",
  posts:"/posts",
  publish:"/publish-and-unpublish",
  contents:"/content-units",
  dashboard:"/dashboard",
  customer_feedback:"/logs/customer-feedbacks",
  get_presigned_url:"/get-presignurl",
};
